import type { MessengerSuccessViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetEmailSuccessViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerSuccessViewSettings>(() => {
    const { title, description } = widgetSettings.value.channels[WebWidgetChannelType.EMAIL].uiSettings.successScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.EMAIL],
      title,
      description,
    }
  })
}
